import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { IconEnum, NavButtonComponent } from "@evc/web-components";
import { EvcButtonType, EvcButtonSize, EvcButtonVariant } from "../../../shared/enumerations/ui-enumerations";
import { NgxSliderModule } from "@angular-slider/ngx-slider";

@Component({
  selector: "app-zoom-slider",
  imports: [NavButtonComponent, NgxSliderModule],
  templateUrl: "./zoom-slider.component.html",
  styleUrl: "./zoom-slider.component.scss"
})
export class ZoomSliderComponent implements OnChanges {
  readonly iconEnums = IconEnum;
  readonly buttonTypes = EvcButtonType;
  readonly buttonSize = EvcButtonSize;
  readonly buttonVariants = EvcButtonVariant;
  options = {
    floor: 1,
    ceil: 1,
    vertical: true,
    showTicks: true,
    showLabels: false,
    showSelectionBar: false
  };
  @Input() value: number = 1;
  @Input() min: number = 1;
  @Input() max: number = 4;
  @Output() zoom = new EventEmitter<number>();

  ngOnChanges({ min, max }: SimpleChanges): void {
    if (min) {
      this.options = { ...this.options, floor: min.currentValue };
    }
    if (max) {
      this.options = { ...this.options, ceil: max.currentValue };
    }
  }
  onZoom() {
    this.zoom?.emit(this.value);
  }

  onZoomPlus() {
    this.value = Math.min(this.value + 1, this.max);
  }

  onZoomMinus() {
    this.value = Math.max(this.value - 1, this.min);
  }
}
